export const DOCUMENTO_TIPOS = [
  { value: "documento_identidad", label: "Documento de identidad" },
  { value: "carnet_tipo_sangre", label: "Carnet tipo de sangre" },
  { value: "libreta_militar", label: "Libreta militar" },
  { value: "certificado_antecedentes", label: "Certificado de antecedentes" },
  { value: "certificado_consejo_judicatura", label: "Certificado consejo de la judicatura" },
  { value: "examen_toxicologico", label: "Examen toxicológico" },
  { value: "examen_psicologico", label: "Examen psicológico" },
  { value: "registro_biometrico", label: "Registro biométrico P.N." },
  { value: "licencia_conducir", label: "Licencia de conducir" },
  { value: "certificado_estudios", label: "Certificado de estudios" },
  { value: "foto", label: "Fotografía" },
  { value: "otro", label: "Otro" },
];

// Tipos finales permitidos (alineado con multer en backend)
export const DOCUMENTOS_MIME_PERMITIDOS = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
];
export const DOCUMENTOS_EXT_PERMITIDAS = [".pdf", ".jpg", ".jpeg", ".png"];
export const DOCUMENTOS_LABEL_FORMATOS = "PDF, JPG o PNG";

export const DOCUMENTO_MAX_MB = 5;

export const DOCUMENTO_ESTADOS = [
  { value: "pendiente", label: "Pendiente" },
  { value: "aprobado", label: "Aprobado" },
  { value: "rechazado", label: "Rechazado" },
  { value: "vencido", label: "Vencido" },
  { value: "no_aplica", label: "No aplica" },
];

export const documentoLabel = (tipo) =>
  DOCUMENTO_TIPOS.find((item) => item.value === tipo)?.label || tipo || "Documento";
